import React from 'react';

function SampleComponent () {
  return (
    <div style={{ display: 'flex', flex: 1, maxHeight: '100%', maxWidth: '100%', justifyContent: 'center', alignItems: 'center', backgroundColor: 'red' }}>SampleComponent</div>
  );
}

export default SampleComponent;
